import { createGlobalStyle } from 'styled-components';
import { typography } from 'src/common/styles/typography';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: ${typography.fontFamilyDefault};
  }

    body {
    line-height: 1.5;
    letter-spacing: 0.012em;
  }


 input::-webkit-outer-spin-button,
 input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
 }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  
::selection {
  background: ${(props) => props.theme.selection.bg}; 
}
`;

/* fonts are imported in css file since globalStyle causes flickering on state changes
https://github.com/styled-components/styled-components/issues/2205 */
